// extracted by mini-css-extract-plugin
export default {"table":"table__YGuWIf","teamInfo":"teamInfo__MyWWBr","title":"title__rWzig2","label":"label__COHeh5","planUsage":"planUsage__AsVuGC","sendEmailHelp":"sendEmailHelp__a1PKYo"};